(function () {
    var script = document.currentScript;
    var sectionId = script.dataset.sectionId;
    var root = document.getElementById('ZehnSearch-' + sectionId);
    if (!root) return;

    window.__zehnSearchModals = window.__zehnSearchModals || {};
    if (window.__zehnSearchModals[sectionId]) {
      window.__zehnSearchModals[sectionId]();
    }

    var input = root.querySelector('[data-zsm-input]');
    var slot = root.querySelector('[data-zsm-slot]');
    var columns = root.querySelector('[data-zsm-columns]');
    var none = root.querySelector('[data-zsm-none]');
    var echo = root.querySelector('[data-zsm-echo]');

    var searchUrl = script.dataset.searchUrl;
    var queryModule = import(script.dataset.queryUrl);
    var limit = Number(script.dataset.limit) || 8;
    var debounceMs = 250;

    var debounceTimer = null;
    var closeTimer = null;
    var controller = null;
    var submitController = null;
    var requestVersion = 0;
    var lastFocused = null;

    function isOpen() {
      return !root.hasAttribute('hidden');
    }

    function lockScroll(lock) {
      document.body.style.overflow = lock ? 'hidden' : '';
    }

    function open() {
      if (isOpen()) return;
      if (closeTimer) clearTimeout(closeTimer);
      lastFocused = document.activeElement;
      root.removeAttribute('hidden');
      root.classList.remove('is-closing');
      lockScroll(true);
      if (input && input.value.trim()) onInput();
      // Matches the React 100ms delay: lets the panel paint before focusing,
      // so mobile keyboards don't fight the entrance animation.
      setTimeout(function () {
        if (input) input.focus();
      }, 100);
    }

    function close() {
      if (!isOpen()) return;
      cancelPending();
      root.classList.add('is-closing');
      lockScroll(false);
      closeTimer = setTimeout(function () {
        root.setAttribute('hidden', '');
        root.classList.remove('is-closing');
      }, 300);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    /* ---------- rendering states ---------- */
    function showState(state, term) {
      // state: 'idle' | 'results' | 'empty'
      columns.classList.toggle('zsm-columns--results', state === 'results');
      slot.hidden = state !== 'results';
      none.hidden = state !== 'empty';
      if (state === 'empty' && echo) echo.textContent = term || '';
      if (state !== 'results') slot.innerHTML = '';
    }

    async function goToSearch(term) {
      var q = (term || '').trim();
      if (!q) return;
      cancelPending();
      submitController = new AbortController();
      var signal = submitController.signal;
      root.setAttribute('aria-busy', 'true');
      try {
        var client = await queryModule;
        signal.throwIfAborted();
        var result = await client.resolveProductSearch(q, {searchUrl: searchUrl, limit: limit, signal: signal});
        signal.throwIfAborted();
        window.location.href = searchUrl + '?type=product&q=' + encodeURIComponent(result.query);
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        window.location.href = searchUrl + '?type=product&q=' + encodeURIComponent(q);
      } finally {
        if (!signal.aborted) root.removeAttribute('aria-busy');
      }
    }

    function cancelPending() {
      requestVersion += 1;
      if (debounceTimer) clearTimeout(debounceTimer);
      if (controller) controller.abort();
      if (submitController) submitController.abort();
      root.removeAttribute('aria-busy');
      slot.setAttribute('data-loading', 'false');
    }

    function fetchResults(term, version) {
      controller = new AbortController();
      var signal = controller.signal;
      slot.setAttribute('data-loading', 'true');

      queryModule
        .then(function (client) {
          signal.throwIfAborted();
          return client.resolveProductSearch(term, {searchUrl: searchUrl, limit: limit, signal: signal});
        })
        .then(function (result) {
          if (signal.aborted || version !== requestVersion || input.value.trim() !== term) return;
          slot.setAttribute('data-loading', 'false');

          if (result.count > 0) {
            slot.innerHTML = result.html;
            showState('results');
          } else {
            showState('empty', term);
          }
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (version !== requestVersion) return;
          slot.setAttribute('data-loading', 'false');
          showState('empty', term);
        });
    }

    function onInput() {
      var term = input.value.trim();
      cancelPending();
      showState('idle');

      if (term.length < 2) {
        return;
      }

      var version = requestVersion;
      debounceTimer = setTimeout(function () {
        fetchResults(term, version);
      }, debounceMs);
    }

    /* ---------- events ---------- */
    function onClick(event) {
      if (event.target.closest('[data-zsm-close]')) {
        event.preventDefault();
        close();
        return;
      }

      if (event.target.closest('[data-zsm-clear]')) {
        event.preventDefault();
        input.value = '';
        onInput();
        input.focus();
        return;
      }

      var term = event.target.closest('[data-zsm-term]');
      if (term) {
        event.preventDefault();
        goToSearch(term.getAttribute('data-zsm-term'));
      }
    }

    function onKeyDownRoot(event) {
      if (event.key === 'Enter' && event.target === input) {
        event.preventDefault();
        goToSearch(input.value);
      }
    }

    function onKeyDown(event) {
      if (event.key === 'Escape' && isOpen()) close();
      if (event.key !== 'Tab' || !isOpen() || root.classList.contains('is-closing')) return;
      // The cart drawer sits above search if both overlays are open.
      if (document.querySelector('[data-zehn-cart-drawer]:not([hidden]):not(.is-closing)')) return;

      // Results change while typing, so resolve the current tab stops each time.
      var focusable = Array.prototype.filter.call(
        root.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'),
        function (element) {
          return element.tabIndex >= 0 && !element.disabled &&
            !element.closest('[hidden], [inert]') && element.getClientRects().length > 0;
        }
      );
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!first) return;

      var active = document.activeElement;
      if (!root.contains(active) || (event.shiftKey ? active === first : active === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      }
    }

    root.addEventListener('click', onClick);
    root.addEventListener('keydown', onKeyDownRoot);
    if (input) input.addEventListener('input', onInput);
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('zehn:search:open', open);

    var form = root.querySelector('[data-zsm-form]');
    if (form) {
      form.addEventListener('submit', onSubmit);
    }

    function onSubmit(event) {
      event.preventDefault();
      goToSearch(input.value);
    }

    window.ZehnSearchModal = {open: open, close: close};

    window.__zehnSearchModals[sectionId] = function () {
      lockScroll(false);
      if (closeTimer) clearTimeout(closeTimer);
      cancelPending();
      root.removeEventListener('click', onClick);
      root.removeEventListener('keydown', onKeyDownRoot);
      if (input) input.removeEventListener('input', onInput);
      if (form) form.removeEventListener('submit', onSubmit);
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('zehn:search:open', open);
    };
  })();

